import React from "react";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

interface TeacherBreadCrumbProps {
  teacherData?: any;
}

// boutton protégée pour modifier un professeur
const ProtectedBtnUpdateTeacher = withPermission(
  (props: any) => (
    <Link
      to={`/edit-teacher/${props.teacherData?.id}`}
      className="btn btn-primary d-flex align-items-center mb-2"
    >
      <i className="ti ti-edit-circle me-2" />
      Editer Professeur
    </Link>
  ),
  [buildPermission(Resource.TEACHER, Action.UPDATE)],
  "masquer",
);

const TeacherBreadcrumb: React.FC<TeacherBreadCrumbProps> = ({
  teacherData,
}) => {
  const routes = my_routes;
  return (
    <div className="col-md-12">
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <div className="my-auto mb-2">
          <h3 className="page-title mb-1">Details Professeur</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={routes.allTeacher}>Professeurs</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Details Professeur
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center  flex-wrap">
          <ProtectedBtnUpdateTeacher teacherData={teacherData} />
        </div>
      </div>
    </div>
  );
};

export default TeacherBreadcrumb;
